import React from 'react'
import { Link } from 'gatsby'

import {
  EuiSpacer,
  EuiButton,
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem
} from '@elastic/eui'

import cloudSearchIcon from '../../../images/Search/MD_SearchThumb_Cloud.webp'
import cloudAccountSearchIcon from '../../../images/Search/MD_SearchThumb_Cloud_Create.webp'
import cloudStorageSearchIcon from '../../../images/Search/MD_SearchThumb_Cloud_Storage.webp'
import cloudManagementSearchIcon from '../../../images/Search/MD_SearchThumb_Cloud_Management.webp'
import cloudAdministrationSearchIcon from '../../../images/Search/MD_SearchThumb_Cloud_Administration.webp'
import cloudRecordingsSearchIcon from '../../../images/Search/MD_SearchThumb_Cloud_Recordings.webp'
import cloudSetsSearchIcon from '../../../images/Search/MD_SearchThumb_Cloud_Sets.webp'


export default function WebUIArticles() {

  return (
    <React.Fragment>
      <EuiFlexItem>
        <EuiFlexGroup gutterSize="l" direction="row" >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/Motion_Detection/INSTAR_Cloud/Create_User_Account/">
                  <img
                    src={cloudAccountSearchIcon}
                    alt="User Account"
                  />
                </Link>
              }
              title="User Account"
              footer={
                <EuiFlexGroup justifyContent="flexEnd">
                  <Link to="/Motion_Detection/INSTAR_Cloud/Create_User_Account/">
                    <EuiFlexItem grow={false}>
                      <EuiButton size="s" fill>
                        More
                      </EuiButton>
                      <EuiSpacer size="s" />
                    </EuiFlexItem>
                  </Link>
                </EuiFlexGroup>
              }
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/Motion_Detection/INSTAR_Cloud/Storage/">
                  <img
                    src={cloudStorageSearchIcon}
                    alt="Storage"
                  />
                </Link>
              }
              title="Storage"
              footer={
                <EuiFlexGroup justifyContent="flexEnd">
                  <Link to="/Motion_Detection/INSTAR_Cloud/Storage/">
                    <EuiFlexItem grow={false}>
                      <EuiButton size="s" fill>
                        More
                      </EuiButton>
                      <EuiSpacer size="s" />
                    </EuiFlexItem>
                  </Link>
                </EuiFlexGroup>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>

      <EuiSpacer />

      <EuiFlexItem>
        <EuiFlexGroup gutterSize="l" direction="row" >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/Motion_Detection/INSTAR_Cloud/User/">
                  <img
                    src={cloudManagementSearchIcon}
                    alt="Management"
                  />
                </Link>
              }
              title="User"
              footer={
                <EuiFlexGroup justifyContent="flexEnd">
                  <Link to="/Motion_Detection/INSTAR_Cloud/User/">
                    <EuiFlexItem grow={false}>
                      <EuiButton size="s" fill>
                        More
                      </EuiButton>
                      <EuiSpacer size="s" />
                    </EuiFlexItem>
                  </Link>
                </EuiFlexGroup>
              }
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/Motion_Detection/INSTAR_Cloud/Administration/">
                  <img
                    src={cloudAdministrationSearchIcon}
                    alt="Administration"
                  />
                </Link>
              }
              title="Administration"
              footer={
                <EuiFlexGroup justifyContent="flexEnd">
                  <Link to="/Motion_Detection/INSTAR_Cloud/Administration/">
                    <EuiFlexItem grow={false}>
                      <EuiButton size="s" fill>
                        More
                      </EuiButton>
                      <EuiSpacer size="s" />
                    </EuiFlexItem>
                  </Link>
                </EuiFlexGroup>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>

      <EuiSpacer />

      <EuiFlexItem>
        <EuiFlexGroup gutterSize="l" direction="row" >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/Motion_Detection/INSTAR_Cloud/Alarm_Recordings/">
                  <img
                    src={cloudRecordingsSearchIcon}
                    alt="Alarm Recordings"
                  />
                </Link>
              }
              title="Alarm Recordings"
              footer={
                <EuiFlexGroup justifyContent="flexEnd">
                  <Link to="/Motion_Detection/INSTAR_Cloud/Alarm_Recordings/">
                    <EuiFlexItem grow={false}>
                      <EuiButton size="s" fill>
                        More
                      </EuiButton>
                      <EuiSpacer size="s" />
                    </EuiFlexItem>
                  </Link>
                </EuiFlexGroup>
              }
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/Motion_Detection/INSTAR_Cloud/Camera_Sets/">
                  <img
                    src={cloudSetsSearchIcon}
                    alt="Camera Sets"
                  />
                </Link>
              }
              title="Camera Sets"
              footer={
                <EuiFlexGroup justifyContent="flexEnd">
                  <Link to="/Motion_Detection/INSTAR_Cloud/Camera_Sets/">
                    <EuiFlexItem grow={false}>
                      <EuiButton size="s" fill>
                        More
                      </EuiButton>
                      <EuiSpacer size="s" />
                    </EuiFlexItem>
                  </Link>
                </EuiFlexGroup>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>

      <EuiSpacer />

      <EuiFlexItem>
        <EuiFlexGroup gutterSize="l" direction="row" >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/Motion_Detection/INSTAR_Cloud/Cloud_Extensions/">
                  <img
                    src={cloudSearchIcon}
                    alt="Cloud Extensions"
                  />
                </Link>
              }
              title="Cloud Extensions"
              footer={
                <EuiFlexGroup justifyContent="flexEnd">
                  <Link to="/Motion_Detection/INSTAR_Cloud/Cloud_Extensions/">
                    <EuiFlexItem grow={false}>
                      <EuiButton size="s" fill>
                        More
                      </EuiButton>
                      <EuiSpacer size="s" />
                    </EuiFlexItem>
                  </Link>
                </EuiFlexGroup>
              }
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/Motion_Detection/INSTAR_Cloud/Delete_Account/">
                  <img
                    src={cloudAdministrationSearchIcon}
                    alt="Delete Account"
                  />
                </Link>
              }
              title="Delete Account"
              footer={
                <EuiFlexGroup justifyContent="flexEnd">
                  <Link to="/Motion_Detection/INSTAR_Cloud/Delete_Account/">
                    <EuiFlexItem grow={false}>
                      <EuiButton size="s" fill>
                        More
                      </EuiButton>
                      <EuiSpacer size="s" />
                    </EuiFlexItem>
                  </Link>
                </EuiFlexGroup>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>
    </React.Fragment>
  );
}
